import { useTranslation } from 'react-i18next';
import { useLocation } from 'react-router-dom';

import { Empty, EmptyHeader, EmptyMedia, EmptyTitle, EmptyDescription } from '@/components/ui/empty';
import { Spinner } from '@/components/ui/spinner';

import { useOidcCallback } from '@/features/oauth-callback';
import { OidcProvider } from '@/shared/config/oidc-config';

export const OAuthCallbackPage = () => {
  const location = useLocation();
  const provider: OidcProvider = location.pathname.includes('/public/oauth') ? OidcProvider.AZURE : OidcProvider.CIAM;
  const { isProcessing } = useOidcCallback(provider);

  const { t } = useTranslation();
  const providerLabel = provider === OidcProvider.AZURE ? 'Azure' : 'CIAM';

  return (
    <Empty className="flex items-center justify-center min-h-screen">
      <EmptyHeader>
        <EmptyMedia variant="icon">
          <Spinner />
        </EmptyMedia>
        <EmptyTitle>
          {isProcessing
            ? t('login.authenticating.message', { provider: providerLabel })
            : t('login.authenticated.message')}
        </EmptyTitle>
        <EmptyDescription>{t('login.verifying.message')}</EmptyDescription>
      </EmptyHeader>
    </Empty>
  );
};
